import { tokens } from '@simplybenefits/sb-ui-library';
import {
    Loyalty as LoyaltyIcon,
    Discount as DiscountIcon,
    RemoveRedEye as RemoveEyeIcon
} from '@mui/icons-material';

/**
 * Get the FYI Doctors appointments URL based on locale
 * @param {string} locale - The current locale (e.g., 'en', 'fr')
 * @returns {string} The localized URL
 */
export const getFyiDoctorsAppointmentsUrl = (locale) => {
    if (locale === 'fr') {
        return 'https://fyidoctors.com/pages/simply-benefits-fr?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits';
    }

    return 'https://fyidoctors.com/pages/simply-benefits?utm_source=simply_benefits&utm_medium=referral&utm_campaign=appointments';
};

/**
 * Get the content blocks with locale-specific links
 * @param {string} locale - The current locale (e.g., 'en', 'fr')
 * @returns {Array} Array of content block objects with localized links
 */
export const getContentBlocks = (locale) => {
    const isFrench = locale === 'fr';

    return [
        {
            icon: LoyaltyIcon,
            titleText: tokens.labels.perks.fyiDoctors20OffFrames,
            description: tokens.labels.perks.fyiDoctorsAllPrescriptionGlasses,
            link: isFrench
                ? "https://visique.com/collections/lunettes?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits"
                : "https://fyidoctors.com/collections/glasses?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits"
        },
        {
            icon: DiscountIcon,
            titleText: tokens.labels.perks.fyiDoctors10OffLifestyleFrames,
            description: tokens.labels.perks.fyiDoctorsIncludesFramesAndLens,
            link: isFrench
                ? "https://visique.com/collections/lunettes?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits"
                : "https://fyidoctors.com/collections/package-pricing-eyeglasses?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits"
        },
        {
            icon: RemoveEyeIcon,
            titleText: tokens.labels.perks.fyiDoctors10OffContactLenses,
            description: tokens.labels.perks.fyiDoctorsRebatesStillApply,
            link: isFrench
                ? "https://visique.com/collections/verres-de-contact?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits"
                : "https://fyidoctors.com/collections/contact-lenses?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits"
        }
    ];
};

/**
 * @returns {object} Object with fyi doctors accordion data
 */
export const getFYIDoctorsSections = (locale) => [
    {
        title: tokens.labels.perks.fyiDoctorsEligibilityAndVerification,
        items: [
            tokens.labels.perks.fyiDoctorsEligibility1,
            tokens.labels.perks.fyiDoctorsEligibility2,
            tokens.labels.perks.fyiDoctorsEligibility3,
            ...(locale === 'fr' ? [ tokens.labels.perks.fyiDoctorsEligibility4 ] : [])
        ]
    },
    {
        title: tokens.labels.perks.fyiDoctorsGeneralConditions,
        items: [
            tokens.labels.perks.fyiDoctorsConditions1,
            tokens.labels.perks.fyiDoctorsConditions2,
            tokens.labels.perks.fyiDoctorsConditions3,
            tokens.labels.perks.fyiDoctorsConditions4,
            tokens.labels.perks.fyiDoctorsConditions5,
            tokens.labels.perks.fyiDoctorsConditions6
        ]
    },
    {
        title: tokens.labels.perks.fyiDoctorsExclusions,
        items: [
            tokens.labels.perks.fyiDoctorsExclusions1,
            tokens.labels.perks.fyiDoctorsExclusions2,
            tokens.labels.perks.fyiDoctorsExclusions3
        ]
    },
    {
        title: tokens.labels.perks.fyiDoctorsPrivacy,
        items: [
            tokens.labels.perks.fyiDoctorsPrivacy1
        ],
        isLast: true
    }
];

/**
 * Get brand URLs based on locale
 * @param {string} locale - The current locale (e.g., 'en', 'fr')
 * @returns {object} Object with brand names as keys and URLs as values
 */
export const getBrandUrls = (locale) => {
    const isFrench = locale === 'fr';

    return {
        fyiDoctors: isFrench
            ? 'https://fyidoctors.com/pages/simply-benefits-fr?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits'
            : 'https://fyidoctors.com?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits',
        visique: isFrench
            ? 'http://visique.com/pages/simply-benefits?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits'
            : 'http://visique.com/pages/simply-benefits-en?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits',
        bonlook: isFrench
            ? 'https://www.bonlook.ca/fr?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits'
            : 'https://www.bonlook.ca?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits',
        solisOptics: 'https://www.solisoptics.ca/?utm_campaign=appointments&utm_medium=referral&utm_source=simply_benefits'
    };
};